import { bl_wms_item_label_list_hdr_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class WMSItemLabelListContainerModel extends BaseContainerModel {
  bl_wms_item_label_list_hdr: bl_wms_item_label_list_hdr_RowClass =
    new bl_wms_item_label_list_hdr_RowClass();
}
